import { render, staticRenderFns } from "./SessionsModal.vue?vue&type=template&id=0a9dbc4c&"
import script from "./SessionsModal.vue?vue&type=script&lang=ts&"
export * from "./SessionsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports